// 导入自己需要的组件
import { CheckboxGroup,Checkbox,Input,Popover } from 'element-ui'
const element = {
    install: function (Vue) {

        Vue.use(CheckboxGroup)
        Vue.use(Checkbox)
        Vue.use(Input)
        Vue.use(Popover)

    }
}
export default element
